<template><ProductDetailBase route-key="/products/500kv" /></template>
<script>
import ProductDetailBase from "./ProductDetailBase.vue";
export default { name: "Product500Page", components: { ProductDetailBase } };
</script>
